/*
 * @Author: zhengxiaowen 
 * @Date: 2018-10-15 14:45:05 
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-15 15:08:38
 */

export default {
  //全局静态变量
  state: {
      testValue: 'testValue'
  },
  getters: {

  },
  
  mutations: {
    CUSTOM_TEST (state) {
      state.testValue = '1111111'
    },
  },
  actions: {
      
  }
}



// WEBPACK FOOTER //
// ./src/store/Custom.js